import { VisitaEstado } from '../consts/visitasStatus';
import { VISIT_TABS_INDEX } from '../../../redux/slices/visitsSlice';

/**
 * Estados que muestra cada pestaña de Visitas (admin BO y Proveedor) cuando el
 * usuario no eligió un estado en el filtro. "Todas" no tiene lista: sin estado
 * elegido no se filtra por estado.
 *
 * Es la misma regla que aplican los endpoints de la grilla en visitasApi
 * (getAllVisits, getRejectedVisits, getPendingVisits, getProgrammedVisits,
 * getInProgressVisits, getInRevisionVisits, getClosedVisitsBO).
 */
export const ESTADOS_POR_TAB: Partial<Record<VISIT_TABS_INDEX, VisitaEstado[]>> = {
    [VISIT_TABS_INDEX.REJECTED]: [VisitaEstado.RECHAZADO, VisitaEstado.SIN_ASIGNAR],
    [VISIT_TABS_INDEX.PENDING]: [VisitaEstado.PENDIENTE],
    [VISIT_TABS_INDEX.PROGRAMMED]: [VisitaEstado.PROGRAMADA],
    [VISIT_TABS_INDEX.IN_PROGRESS]: [VisitaEstado.EN_PROCESO],
    [VISIT_TABS_INDEX.IN_REVISION]: [VisitaEstado.REALIZADA],
    [VISIT_TABS_INDEX.CLOSED]: [
        VisitaEstado.FALLIDA,
        VisitaEstado.PRESENTADO,
        VisitaEstado.CANCELADA
    ]
};

// Pestañas donde el estado elegido en el filtro reemplaza a la lista de la pestaña.
// En las de un solo estado (Pendientes, Programadas, En proceso, En revisión) la
// grilla siempre usa el estado propio de la pestaña.
const TABS_CON_FILTRO_DE_ESTADO = [
    VISIT_TABS_INDEX.ALL,
    VISIT_TABS_INDEX.REJECTED,
    VISIT_TABS_INDEX.CLOSED
];

/**
 * `idsEstado` que corresponde a la pestaña y al estado elegido en el filtro,
 * igual que la grilla. Un arreglo vacío significa "sin filtro de estado".
 */
export const resolverIdsEstado = (
    tab: VISIT_TABS_INDEX,
    estado?: number | null
): VisitaEstado[] => {
    const hayEstadoElegido =
        estado !== undefined && estado !== null && TABS_CON_FILTRO_DE_ESTADO.includes(tab);
    if (hayEstadoElegido) return [estado as VisitaEstado];
    return ESTADOS_POR_TAB[tab] ?? [];
};
